import { StopAddressType, StopTimeType, StopType } from "types/MultiStop";

export interface ScheduleStopValue {
  address_id?: number;
  stop_key: string;
  stop_type: StopType;
  stop_time_type: StopTimeType;
  stop_address_type: StopAddressType;

  stop_airport_name?: string;
  stop_airport_code?: string;
  stop_seaport_name?: string;
  stop_seaport_code?: string;

  address_name?: string;
  address_reference_number?: string;
  street_address?: string;
  street_address_line_two?: string;
  zipcode?: string;
  city_name?: string;
  city_id?: number | string;
  state_name?: string;
  state_id?: number | string;
  country_name?: string;
  country_id?: number | string;
  port_country?: string;
  un_locode?: string;
  location_reference_number?: string;
  custom_address_reference?: string;

  stop_contact_name?: string | null;
  stop_contact_number?: string | null;
  stop_contact_email?: string | null;

  stop_after_date?: string | null;
  stop_after_time?: string | null;
  stop_before_date?: string | null;
  stop_before_time?: string | null;
  stop_notes?: string;
  stop_hours_start?: string | null;
  stop_hours_end?: string | null;
  stop_timezone?: string | null;
}

const getBaseStopValue = (): ScheduleStopValue => ({
  stop_key: crypto.randomUUID(),
  stop_type: StopType.DROPOFF,
  stop_time_type: StopTimeType.BEFORE,
  stop_address_type: StopAddressType.ADDRESS,

  stop_airport_name: "",
  stop_airport_code: "",
  stop_seaport_name: "",
  stop_seaport_code: "",

  address_name: "",
  address_reference_number: "",
  street_address: "",
  street_address_line_two: "",
  zipcode: "",
  city_name: "",
  state_name: "",
  country_name: "",
  port_country: "",

  stop_contact_name: null,
  stop_contact_number: null,
  stop_contact_email: null,

  stop_after_date: null,
  stop_after_time: null,
  stop_before_date: null,
  stop_before_time: null,
  stop_notes: "",
  stop_hours_start: null,
  stop_hours_end: null,
  stop_timezone: null,
});

export const getDefaultPickupStopValue = (): ScheduleStopValue => ({
  ...getBaseStopValue(),
  stop_type: StopType.PICKUP,
  stop_time_type: StopTimeType.AFTER,
  stop_after_time: "09:00:00",
  stop_before_time: "09:00:00",
});

export const getDefaultDeliveryStopValue = (): ScheduleStopValue => ({
  ...getBaseStopValue(),
  stop_type: StopType.DROPOFF,
  stop_time_type: StopTimeType.BEFORE,
  stop_before_time: "17:00:00",
  stop_after_time: "17:00:00",
});

export function getDefaultScheduleStops(): ScheduleStopValue[] {
  return [getDefaultPickupStopValue(), getDefaultDeliveryStopValue()];
}
